/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import ReportSchedule from 'pages/dashboard/reports/detail/schedule/schedule';



/* ========== ~~~~~~~~~~ REPORT SCHEDULE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState }) => ({
    emails: reportsState.selectedReportStatus.selectedReportData.emails,
    schedule: reportsState.selectedReportStatus.selectedReportData.schedule,
    endDate: reportsState.selectedReportStatus.selectedReportData.endDate,
    dateRange: reportsState.selectedReportStatus.selectedReportData.dateRange,
    selectedReportDataValid: reportsState.selectedReportStatus.selectedReportData.selectedReportDataValid,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
});

// map actions
const mapDispatchToProps = dispatch => ({
    setReportProperties: data => dispatch(setReportProperties(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportSchedule);
